const getters = {
  // sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  avatar: state => state.user.avatar?state.doMainName+state.user.avatar : '',
  name: state => state.user.name,
  phone: state => state.user.phone,
  withdrawObj: state => state.user.withdrawObj,
  roles: state => state.user.roles,
  game_num: state => state.user.game_num,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js